var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading balloon-message",style:({
        'background': _vm.color.balloonOtr + '!important',
        'color': _vm.autoColor(_vm.color.balloonOtr),
        'filter': _vm.shadowStyle()})},_vm._l(('・・・'),function(m,i){return _c('span',{key:i},[_vm._v(_vm._s(m))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78f95008","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/MogoMogo.vue
// module id = null
// module chunks = 